import {
  ApiTypesV1GroupResponse,
  GroupApprovalStatus,
} from '@wix/social-groups-api';

export function isApprovalStatusPending(group: ApiTypesV1GroupResponse) {
  return group.approvalStatus === GroupApprovalStatus.PENDING;
}
